export default __webpack_public_path__ + "static/media/Cart.85893f37.svg";